<div edsPadding edsPaddingAll="lg">
  <div edsSpacing="lg">
    <eds-image
      imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
      imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
    >
    </eds-image>
  </div>
  <p *ngIf="!isPrimericaUser; else primericaUser">
    {{ "literature.lit-my-literature-overlay-no-row" | translate }}
  </p>
  <ng-template #primericaUser>
    <p>
      {{ "literature.lit-my-literature-overlay-primerica" | translate }}
    </p>
  </ng-template>
</div>
